// extracted by mini-css-extract-plugin
export default {"bg":"Sobre_bg__ak9sB","main":"Sobre_main__jIz1P","socialIcon":"Sobre_socialIcon__jZDau","githubIcon":"Sobre_githubIcon__EXZ6u","linkedinIcon":"Sobre_linkedinIcon__qr2Ma"};